<template>
    <dialogFilter v-model="localShowFilterDialog" :title="$t('invoices.invoice')" @cancel="handleCancel"
        @update:filteredInvoices="handleConfirm" ref="dialogFilterInvoices" />
    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :ColonneWidth="colonneWidth" :GetFunction="InvoicesList">
        <template v-slot:[SlotsFilters.Filter0]="{ index }">
            <ColumnFilter :title="$t('invoices.reference')" :Filter="FieldReference" :getList="InvoicesList"
                @cancel="FieldReference = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="FieldReference" id="FieldReference" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:[SlotsFilters.Filter1]="{ index }">
            <ColumnFilter :title="$t('invoices.title')" :Filter="FieldName" :getList="InvoicesList"
                @cancel="FieldName = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="FieldName" id="FieldName" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:[SlotsFilters.Filter2]>
            <ColumnFilter :title="$t('invoices.company')" :Filter="FieldCompany" :getList="InvoicesList"
                @cancel="FieldCompany = null">
                <template v-slot:input>
                    <v-text-field v-model="FieldCompany" id="FieldCompany" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:[SlotsFilters.Filter3]>
            <ColumnFilter :title="$t('purchaseOrder.supplier')" :Filter="FieldSupplier" :getList="InvoicesList"
                @cancel="FieldSupplier = []">
                <template v-slot:input>
                    <v-autocomplete id="Supplier" name="Supplier" class="pl-2" variant="outlined"
                        v-model="FieldSupplier" v-model:search="SupplierSearch" persistent-placeholder
                        :placeholder="FieldSupplier.length == 0 ? $t('placeholder.select', { itm: $t('purchaseOrder.supplier') }) : ''"
                        :items="SupplierList" item-title="brandName" item-value="brandName" hide-details multiple>
                        <template v-slot:item="{ props, item, index }">
                            <v-list-item v-bind="props" variant="text" :id="index" :name="item.brandName"
                                @click="removeSupplier(item)">
                                {{ item.brandName }}
                            </v-list-item>
                        </template>
                        <template v-slot:selection="{ props, item, index }">
                            <v-chip v-if="index < 1" v-bind="props" variant="text" :id="index" :name="item.title">
                                {{ FieldSupplier.length <= 1 ? item.title : FieldSupplier.length + ' ' +
        $t('suppliers.supplierSelected') }} </v-chip>
                        </template>
                    </v-autocomplete>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:[SlotsFilters.Filter4]>
            <ColumnFilter :title="$t('invoices.amountTTC')" :Filter="FieldAmountTTC" :getList="InvoicesList"
                @cancel="FieldAmountTTC = null">
                <template v-slot:input>
                    <div class="col-12 justify-content-start">
                        <div class="row">
                            <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{ $t('invoices.MinamountTTC')
                                }}</v-card-title>
                        </div>
                        <v-text-field v-model="FiledMinAmountTTC" maxlength="9" @update:model-value="validateAmounts"
                            hide-details :placeholder="$t('placeholder.enter', { itm: $t('invoices.MinamountTTC') })"
                            variant="outlined" class="mt-n4 text-left"></v-text-field>
                        <span v-if="errors.minAmount" class="error-message">{{ errors.minAmount }}</span>

                    </div>
                    <div class="col-12 justify-content-start">
                        <div class="row">
                            <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{ $t('invoices.MaxamountTTC')
                                }}</v-card-title>
                        </div>
                        <v-text-field v-model="FiledMaxAmountTTC" maxlength="9" @update:model-value="validateAmounts"
                            hide-details :placeholder="$t('placeholder.enter', { itm: $t('invoices.MaxamountTTC') })"
                            variant="outlined" class="mt-n4 text-left"></v-text-field>
                        <span v-if="errors.maxAmount" class="error-message">{{ errors.maxAmount }}</span>
                    </div>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:[SlotsFilters.Filter5]>
            <ColumnFilter :title="$t('purchaseOrder.deliverydate')" :Filter="FieldDeadline" :getList="InvoicesList"
                @cancel="FieldDeadline = null">
                <template v-slot:input>
                    <dateField v-model="FieldDeadline" :min-date="new Date('2000-01-01')"
                        :model-value="Deadline" range-enabled @update:model-value="handleDateRangeDeadline" />
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:[SlotsFilters.Filter6]>
            <ColumnFilter :title="$t('invoices.status')" :Filter="FieldStatus" :getList="InvoicesList"
                @cancel="FieldStatus = []">
                <template v-slot:input>
                    <v-checkbox-group multiple class="d-flex flex-row" style="margin-top: 6px;">
                        <v-checkbox v-model="FieldStatus" :label="isSubmitted" :value="0" id="Submitted"
                            name="Submitted" class="mr-4"></v-checkbox>
                        <v-checkbox v-model="FieldStatus" :label="isRefused" :value="1" id="Refused" name="Refused"
                            class="mr-4"></v-checkbox>
                        <v-checkbox v-model="FieldStatus" :label="isValidated" :value="2" id="Validated"
                            name="Validated" class="mr-4"></v-checkbox>
                        <v-checkbox v-model="FieldStatus" :label="isPaid" :value="3" id="Paid" name="Paid"
                            class="mr-4"></v-checkbox>
                    </v-checkbox-group>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:[SlotsFilters.Filter7]>
            <ColumnFilter :title="$t('invoices.creationDate')" :Filter="FieldCreatedDate" :getList="InvoicesList"
                @cancel="FieldCreatedDate = null">
                <template v-slot:input>
                    <span lang="en-CA" xml:lang="en-CA">
                        <dateField v-model="FieldCreatedDate" :min-date="new Date('2000-01-01')" :max-date="new Date()"
                            :model-value="Deadline" range-enabled @update:model-value="handleDateRangeCreationDate" />
                    </span>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:[SlotsItems.item0]="{ item }">{{ item.reference }}</template>
        <template v-slot:[SlotsItems.item1]="{ item }">{{ item.title }}</template>
        <template v-slot:[SlotsItems.item2]="{ item }">
            <span v-if="item.company">{{ item.company.brandName }}</span>
            <v-chip v-else color="red">
                {{ $t('invoices.alertDelete') }}
            </v-chip>
        </template>
        <template v-slot:[SlotsItems.item3]="{ item }">
            <span v-if="item.supplier">{{ item.supplier.brandName }}</span>
            <v-chip v-else color="red">
                {{ $t('invoices.alertDelete') }}
            </v-chip>
        </template>
        <template v-slot:[SlotsItems.item4]="{ item }">{{ formatPrice(item.amountTTC) }}</template>
        <template v-slot:[SlotsItems.item5]="{ item }">{{ item.deadline.split('T')[0] }}</template>
        <template v-slot:[SlotsItems.item6]="{ item }">
            <StatusButton v-if="item" :title="statut(item)" />
        </template>
        <template v-slot:[SlotsItems.item7]="{ item }">{{ item.created.split('T')[0] }}</template>
        <template v-slot:edit="{ item, index }">
            <EditInvoice v-bind:getInvoice="item" :Id="index" v-bind:getInvoicesListAfterDelete="InvoicesList" />
        </template>
    </gridComponent>
</template>
<script>
import EditInvoice from "./EditInvoice.vue";
import StatusButton from "@/genericComponent/StatusButton.vue";
import gridComponent from "@/genericComponent/gridComponent.vue";
import { GetSupplierFromInvoices, GetAllInvoices, GetCompanyFromInvoices, CheckPermissionByUser, isClient, isSupplier, GetStatusInvoices, ExportInvoicesToExcel, formatPrice } from "@/api/index";
import ColumnFilter from "@/genericComponent/ColumnFilter.vue";
import dialogFilter from "@/genericComponent/dialogFilter.vue";
import dateField from "@/genericComponent/date-field.vue";
import { status } from "@/enums/Status";

export default {
    props: {
        showFilterDialog: Boolean,
    },
    components: { EditInvoice, StatusButton, gridComponent, ColumnFilter, dateField, dialogFilter },
    data() {
        return {
            loader: true,
            page: 1,
            PageSize: 10,
            items: {},
            itemsData: {},
            CompanyList: [],
            search: null,
            FieldReference: null,
            FieldName: null,
            FiledMinAmountTTC: null,
            FiledMaxAmountTTC: null,
            FieldDeadline: [],
            FieldDeadlineFrom: null,
            FieldDeadlineTo: null,
            FieldCompany: null,
            FieldSupplier: [],
            FieldAmountTTC: null,
            FieldStatus: [],
            FieldCreatedDate: [],
            FieldCreatedDateFrom: null,
            FieldCreatedDateto: null,
            WithStatus: false,
            ExportFiltered: false,
            dialogCompose: false,
            dialogfilter: false,
            SortedBy: null,
            SortingType: null,
            HasPermissionValidation: false,
            isClientVar: this.isClient(),
            isSupplierVar: this.isSupplier(),
            localShowFilterDialog: this.showFilterDialog,
            itemsfilters: [],
            dialogFilterInvoicesRef: null,
            SupplierSearch: null,
            SupplierList: [],
            errors: {
                minAmount: '',
                maxAmount: ''
            },
        }
    },
    created() {
        this.GetStatusInvoices();
    },
    mounted() {
        this.GetCompanyList();
        this.emitter.off('event-test')
        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.search = event;
            this.InvoicesList();
        })

        this.dialogFilterInvoicesRef = this.$refs.dialogFilterInvoices;
    },
    unmounted() {
        this.emitter.off('event-test')
        this.emitter.emit('remise-search-at-null');
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price)
        },
        handleNullableFilters() {
            this.FieldReference = null;
            this.FieldName = null;
            this.FieldSupplier = null;
            this.FiledMinAmountTTC = null;
            this.FiledMaxAmountTTC = null;
            this.FieldDeadlineFrom = null;
            this.FieldDeadlineTo = null;
            this.FieldCreatedDateFrom = null;
            this.FieldCreatedDateto = null;
            this.FieldStatus = null;
            this.$refs.dialogFilterInvoices.cleardialogfilter();
            this.InvoicesList(1);
        },
        handleCancel() {
            this.localShowFilterDialog = false;
        },
        handleConfirm(Reference, Title, Supplier, MinAmountTTC, MaxAmountTTC, DeadlineFrom, DeadlineTo, CreatedFrom, CreatedTo, ValidationStatus) {
            this.FieldReference = Reference;
            this.FieldName = Title;
            this.FieldSupplier = Supplier;
            this.FiledMinAmountTTC = MinAmountTTC;
            this.FiledMaxAmountTTC = MaxAmountTTC;
            this.FieldDeadlineFrom = DeadlineFrom;
            this.FieldDeadlineTo = DeadlineTo;
            this.FieldCreatedDateFrom = CreatedFrom;
            this.FieldCreatedDateto = CreatedTo;
            this.FieldStatus = ValidationStatus;
            this.InvoicesList();
            this.localShowFilterDialog = false;
        },

        handleDateRangeDeadline(value) {
            if (Array.isArray(value) && value.length === 2) {
                this.FieldDeadlineFrom = value[0];
                this.FieldDeadlineTo = value[1];
            }
            else {
                this.FieldDeadlineFrom = null;
                this.FieldDeadlineTo = null;
            }
        },
        handleDateRangeCreationDate(value) {
            if (Array.isArray(value) && value.length === 2) {
                this.FieldCreatedDateFrom = value[0];
                this.FieldCreatedDateto = value[1];
            } else {
                this.FieldCreatedDateFrom = null;
                this.FieldCreatedDateto = null;
            }

        },
        validateAmounts() {
            this.errors.minAmount = '';
            this.errors.maxAmount = '';
            this.FiledMinAmountTTC = this.FiledMinAmountTTC ? this.FiledMinAmountTTC.replace(/[^0-9.]/g, '') : null;
            this.FiledMaxAmountTTC = this.FiledMaxAmountTTC ? this.FiledMaxAmountTTC.replace(/[^0-9.]/g, '') : null;

            const minAmount = parseFloat(this.FiledMinAmountTTC);
            const maxAmount = parseFloat(this.FiledMaxAmountTTC);

            if (!isNaN(minAmount) && !isNaN(maxAmount)) {
                if (minAmount > maxAmount) {
                    this.errors.minAmount = this.$t('invoices.validationTab.minAmountGreater');
                    this.errors.maxAmount = this.$t('invoices.validationTab.maxAmountSmaller');
                }

            }
        },
        removeSupplier(selectedItem) {
            this.FieldSupplier.filter(i => i != selectedItem);
        },
        GetSupplierList() {
            GetSupplierFromInvoices(this.SupplierSearch)
                .then((res) => {
                    this.SupplierList = res.data;
                })
        },

        GetCompanyList() {
            GetCompanyFromInvoices("")
                .then((res) => {
                    this.CompanyList = res.data;
                })
        },
        async exportToExcel() {
            try {
                const response = await ExportInvoicesToExcel(this.FieldReference, !this.FieldName ? this.search : this.FieldName, this.FieldCompany, this.FieldSupplier, this.FiledMinAmountTTC, this.FiledMaxAmountTTC, this.FieldDeadlineFrom, this.FieldDeadlineTo, this.FieldStatus, this.FieldCreatedDateto, this.FieldCreatedDateFrom, this.SortedBy, this.SortingType);
                // Créez un lien pour télécharger le fichier
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Invoices.xlsx'); // Nom du fichier téléchargé
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error('Error downloading invoices:', error);
            }
        },
        InvoicesList: function (page) {
            if (page) { this.page = page }
            CheckPermissionByUser("Optima.Invoices.Validate").then((response) => {
                this.HasPermissionValidation = response.data
            }).finally(() => {
                GetAllInvoices(this.page, this.PageSize, this.FieldReference, !this.FieldName ? this.search : this.FieldName, this.FieldCompany, this.FieldSupplier, this.FiledMinAmountTTC, this.FiledMaxAmountTTC, this.FieldDeadlineFrom, this.FieldDeadlineTo, this.FieldStatus, this.FieldCreatedDateto, this.FieldCreatedDateFrom, this.SortedBy, this.SortingType, this.HasPermissionValidation).then((response) => {
                    this.items = response.data.items;
                    this.itemsData.numberOfPage = response.data.totalPages;
                    this.itemsData.totalItemsCount = response.data.totalCount;
                    this.itemsData.pageNumber = response.data.pageNumber;
                    this.itemsData.hasPreviousPage = response.data.hasPreviousPage
                    this.itemsData.hasNextPage = response.data.hasNextPage
                    this.loader = false;
                    this.page = 1;
                });
                
            })
        },
        isClient() {
            return isClient()
        },
        isSupplier() {
            return isSupplier()
        },
        GetStatusInvoices() {
            GetStatusInvoices().then(response => {
                localStorage.setItem(status.Submitted + this.$i18n.availableLocales[0], response.data.Submitted.en);
                localStorage.setItem(status.Submitted + this.$i18n.availableLocales[1], response.data.Submitted.fr);
                localStorage.setItem(status.Refused + this.$i18n.availableLocales[0], response.data.Refused.en);
                localStorage.setItem(status.Refused + this.$i18n.availableLocales[1], response.data.Refused.fr);
                localStorage.setItem(status.Validated + this.$i18n.availableLocales[0], response.data.Validated.en);
                localStorage.setItem(status.Validated + this.$i18n.availableLocales[1], response.data.Validated.fr);
                localStorage.setItem(status.Paid + this.$i18n.availableLocales[0], response.data.Paid.en);
                localStorage.setItem(status.Paid + this.$i18n.availableLocales[1], response.data.Paid.fr);
            })
        },
    },
    watch: {
        showFilterDialog(value) {
            this.localShowFilterDialog = value;
        },
        SupplierSearch(value) {
            if (this.SupplierSearch != null && this.SupplierSearch.length == 1) this.SupplierSearch = value.trim();
            this.GetSupplierList();
        },
    },
    computed: {
        statut() {
            return item => {
                switch (item.validationStatus) {
                    case 0: return localStorage.getItem(status.Submitted + this.$i18n.locale);
                    case 1: return localStorage.getItem(status.Refused + this.$i18n.locale);
                    case 2: return localStorage.getItem(status.Validated + this.$i18n.locale);
                    case 3: return localStorage.getItem(status.Paid + this.$i18n.locale);
                    default: return localStorage.getItem(status.Submitted + this.$i18n.locale);
                }
            };
        },
        headers() {
            const headers = [
                this.$t('invoices.reference'),
                this.$t('invoices.title'),
                this.$t('invoices.company'),
                this.$t('invoices.supplier'),
                this.$t('invoices.amountTTC'),
                this.$t('purchaseOrder.deliverydate'),
                this.$t('invoices.status'),
                this.$t('invoices.creationDate'),
            ];

            const isClient = this.isClientVar;
            const isSupplier = this.isSupplierVar;

            if (isClient && !isSupplier) {
                return headers.slice(0, 2).concat(headers.slice(3));
            }
            if (isSupplier && !isClient) {
                return headers.slice(0, 3).concat(headers.slice(4));
            }

            return headers;
        },
        SlotsItems() {
            const items = {
                item0: 'item',
                item1: 'item',
                item2: 'item',
                item3: 'item',
                item4: 'item',
                item5: 'item',
                item6: 'item',
                item7: 'item',
            }
            if (this.isSupplierVar && !this.isClientVar) {
                delete items.item3;
            }
            if (this.isClientVar && !this.isSupplierVar) {
                delete items.item2;
            }
            let i = 0;
            for (const key in items) {
                items[key] = 'item' + i
                i = i + 1;
            }
            return items;
        },
        SlotsFilters() {
            const filters = {
                Filter0: 'Filter',
                Filter1: 'Filter',
                Filter2: 'Filter',
                Filter3: 'Filter',
                Filter4: 'Filter',
                Filter5: 'Filter',
                Filter6: 'Filter',
                Filter7: 'Filter',
            }
            if (this.isSupplierVar && !this.isClientVar) {
                delete filters.Filter3;
            }
            if (this.isClientVar && !this.isSupplierVar) {
                delete filters.Filter2;
            }
            let i = 0;
            for (const key in filters) {
                filters[key] = 'Filter' + i
                i = i + 1;
            }
            return filters;
        },
        colonneWidth() {
            const headers = ['10%', '35%', '15%', '15%', '5%', '5%', '5%', '5%'];
            const isClient = this.isClientVar;
            const isSupplier = this.isSupplierVar;

            if (isClient && !isSupplier) {
                return headers.slice(0, 1).concat(headers.slice(2));
            }
            if (isSupplier && !isClient) {
                return headers.slice(0, 2).concat(headers.slice(3));
            }

            return headers;
        },
        isSubmitted() {
            return localStorage.getItem(status.Submitted + this.$i18n.locale);
        },
        isPaid() {
            return localStorage.getItem(status.Paid + this.$i18n.locale);
        },
        isRefused() {
            return localStorage.getItem(status.Refused + this.$i18n.locale);
        },
        isValidated() {
            return localStorage.getItem(status.Validated + this.$i18n.locale);
        },
    }
};
</script>

<style scoped>
.custom-card-title {
    font-size: 16px;
    color: #5b6d8e;
}

.error-message {
    color: red;
    font-size: 14px;
}
</style>